import React from 'react';
import './styles.css';
const LoadingTables = () => {
  return (
    <div
      className="min-w-screen animated fadeIn faster outline-none  focus:outline-none  fixed inset-0 left-0 top-0 z-50 flex h-screen items-center justify-center overflow-y-scroll bg-cover bg-center bg-no-repeat"
      id="modal-id">
      <div className="fixed inset-0 z-0 opacity-50"></div>
      <span className="loaderTable"></span>
      <span className="loaderTable"></span>
    </div>
  );
};
export default LoadingTables;
